// @ts-nocheck
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

interface ManualCoachInvitationFormProps {
  eventId: string;
  eventName: string;
  organizationId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

const ManualCoachInvitationForm: React.FC<ManualCoachInvitationFormProps> = ({
  eventId,
  eventName,
  organizationId,
  onSuccess,
  onCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    coachName: '',
    coachEmail: '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.coachName || !formData.coachEmail) {
      toast.error('Coach name and email are required');
      return;
    }

    setLoading(true);

    try {
      // The invitation row and the email are both created server side:
      // coach_invitations requires fields the browser cannot supply, and the
      // send is authorised as an operator of this event's organisation.
      const { data, error } = await invokeEdgeFunction('send-coach-event-invitation', {
        body: {
          event_id: eventId,
          coach_name: formData.coachName,
          coach_email: formData.coachEmail,
        },
      });

      if (error) throw error;
      if (data?.error) throw new Error(data.error);

      toast.success('Coach invitation sent successfully');
      onSuccess();
    } catch (error: any) {
      console.error('Error sending coach invitation:', error);
      toast.error(error.message || 'Failed to send invitation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-4">
        <div className="p-3 bg-muted rounded-lg">
          <p className="text-sm">
            <span className="font-medium">Event:</span> {eventName}
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="coachName">Coach Name *</Label>
          <Input
            id="coachName"
            value={formData.coachName}
            onChange={(e) => setFormData({ ...formData, coachName: e.target.value })}
            placeholder="John Smith"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="coachEmail">Coach Email *</Label>
          <Input
            id="coachEmail"
            type="email"
            value={formData.coachEmail}
            onChange={(e) => setFormData({ ...formData, coachEmail: e.target.value })}
            placeholder="coach@example.com"
            required
          />
          <p className="text-xs text-muted-foreground">
            An invitation email will be sent to this address
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <Button type="button" variant="outline" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button type="submit" disabled={loading}>
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Send Invitation
        </Button>
      </div>
    </form>
  );
};

export default ManualCoachInvitationForm;